import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import { Helmet } from "react-helmet";

function Cex() {
  return (
    <div className="newpage header_section  IEO_txtcontent">
      <header className="newpage nft_new_page  ">
        <Header />
      </header>
      <div className="paddin_immner">
        <main className=" carer_page">
          <span>
            <Helmet>
              <title>
                IEO Development Company | Initial Exchange Offering(IEO)
                Development Services | Beleaf Technologies
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/ieo-development-company"
              />
              <meta
                name="title"
                content=" IEO Development Company | Initial Exchange Offering(IEO) Development Services | Beleaf Technologies"
              />
              <meta
                name="description"
                content="IEO development company ready to launch your fund-raising platform. With the help of IEO you can identify the potential investors for your business to enhancing your returns. Hire Our team of Initial exchange offering developers"
              />
              <meta
                name="keywords"
                content="IEO Development Company, Initial Exchange Offering (IEO) Development Services,IEO Development Services, IEO Marketing Services, Initial Exchange Offering, Cryptocurrency Exchange Platform"
              />
            </Helmet>

            <section className="main_banner_swcrir">
              <div className="container">
                <div className="card_contane">
                  <div className="row">
                    <div className="col-lg-4"></div>
                    <div className="col-sm-12 col-lg-8 ">
                      <div className="banner_contentc_section">
                        <h1>Initial Exchange Offering (IEO)</h1>
                        <p>
                          Facilitate the launching & fundraising process with
                          top-notch and cutting-edge IEO Development Services to
                          boom your business in the market!!
                        </p>
                        <Button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="m-auto d-block mt-4"
                          aria-label="Start A Discussion"
                        >
                          Start A Discussion
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* <div className="ourserveic_banner ico-banner">
             
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="service_content">
                      <h1 className="text-center">
                        DRIVE ICO DEVELOPMENT TO RAISE FUNDS!!
                      </h1>
                      <p className="text-center mb-5">
                        Mission-driven ICO Development Services will accentuate
                        fundraising and energize your firm for long-term
                        success.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="m-auto d-block mt-4"
                      >
                        Develop Your Own ICO Token
                      </Button>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text-center text_center_new">
                        IEO Development Company
                      </h2>
                      <p className="text-center">
                        Initial Exchange Offering is a concept with numerous
                        choices for project owners, investors, and exchanges.
                        Since, there is a rise in developing a IEO, Beleaf
                        offers IEO development services that ensure your
                        project's acceptability and dependability on all fronts.
                        <br />
                        With our services, we ensure that you get what you
                        anticipate from your project. We are an IEO development
                        firm that seeks to provide you with a productive
                        workplace and a scalable growth opportunity. Our mission
                        is to ensure that your product reaches its target
                        audience and converts them into investors. We provide
                        great IEO marketing services that solidify your
                        company's vision through a comprehensive and strategic
                        approach.
                      </p>
                      <div className="button_CTA_block">
                        <a href="https://wa.me/7904323274" target="_blank">
                          Connect Us Via Whatsapp
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2>
                        Why IEO is better than other Fundraising models
                        <br />
                      </h2>
                      <p className="text-center mb-5">
                        Unlike its rivals, IEO is done through an exchange
                        platform, making the projects more reliable for
                        investors. In an ICO/STO campaign, the tokens are sold
                        alone, with no external entity guaranteeing the
                        initiatives. The exchange platform verifies the
                        project's legitimacy and acquires token ownership. This
                        entire approach makes IEO a much better option for
                        everyone.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete new_our_furtur ico-site-sectio card_heignt_section grid_ful_height_tab">
                      <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/IEO/donation.webp")}
                                alt=""
                                className="mockup_img"
                              />
                            </div>
                            <div>
                              <h4>Fundraising Methodology</h4>
                              <p>
                                You don't require admin and investor dashboards
                                to start an IEO. The crypto exchange, on the
                                other hand, is in charge of running the
                                fundraising campaign for the companies trying to
                                raise funding
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/IEO/candidate.webp")}
                                alt=""
                                className="mockup_img"
                              />
                            </div>
                            <div>
                              <h4>Screening</h4>
                              <p>
                                Since exchange platforms check and approve
                                projects and investors based on their factors
                                before releasing them on the platform, the cost
                                of compliance for enterprises is significantly
                                lowered.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/IEO/smart-contract.webp")}
                                alt=""
                                className="mockup_img"
                              />
                            </div>
                            <div>
                              <h4>Smart Contracts Regulation</h4>
                              <p>
                                When it comes to administering an IEO project,
                                the exchange platform is in charge of
                                maintaining smart contract laws. Companies are
                                not required to build or administer smart
                                contracts for token sales.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/IEO/digital-marketing.webp")}
                                alt=""
                                className="mockup_img"
                              />
                            </div>
                            <div>
                              <h4>Marketing/Outreaching</h4>
                              <p>
                                Companies can save money and time by allowing
                                the exchange platform to handle token sales and
                                AML/KYC checks, allowing them to invest in
                                marketing and reaching out to more investors to
                                generate funding.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/IEO/trust.webp")}
                                alt=""
                                className="mockup_img"
                              />
                            </div>
                            <div>
                              <h4>Trust</h4>
                              <p>
                                As the project becomes live following a
                                comprehensive vetting by exchange platform
                                providers, investors gain more trust in the IEO
                                project tokens. As additional investors invest
                                in the project, the corporations must raise more
                                capital.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/IEO/kyc.webp")}
                                alt=""
                                className="mockup_img"
                              />
                            </div>
                            <div>
                              <h4>KYC/AML</h4>
                              <p>
                                Following a strict method to protect your
                                projects from any suspicious user who could
                                endanger the future of your project through
                                annoying tactics.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2>Our Top-Rate IEO Development Services</h2>
                      <p className="text-center">
                        Our team of talented developers provides fantastic
                        Initial Exchange Offering solutions by creating
                        well-compliant tokens. After the tokens have been
                        generated, our technical experts will assist you with
                        listing them on your cryptocurrency exchanges.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete card_P2P_new card_P2P_new2">
                      <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section coin_class">
                              <img
                                src={require("../../image/IEO/money.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Coin/Token Creation</h4>
                            <p>
                              We collaborate with startups to help them create
                              their own token or coin. You can create an
                              Etheruem token, Stellar, or any cryptocurrency
                              that is entirely compatible.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section coin_class">
                              <img
                                src={require("../../image/IEO/currency-exchange.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Crypto Exchange Listing</h4>
                            <p>
                              We begin listing your currencies in your exchange
                              after they have been developed on our end. If you
                              don't already have one, we'll set one up for you.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section coin_class">
                              <img
                                src={require("../../image/IEO/research.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Light Paper Production</h4>
                            <p>
                              We quickly provide you with the project outline in
                              the form of a Light Paper for easy comprehension.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section coin_class">
                              <img
                                src={require("../../image/IEO/paper.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Creating a White Paper</h4>
                            <p>
                              Beleaf is the Best WhitePaper Writing Service
                              Providers that provide High-Quality White Papers
                              for all Crypto Projects in order to attract
                              investors and raise money for your company.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section coin_class">
                              <img
                                src={require("../../image/IEO/business.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Project Proposal</h4>
                            <p>
                              In a brief presentation, we provide a quick
                              outline of the IEO project to possible investors.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section coin_class">
                              <img
                                src={require("../../image/IEO/bitcoin.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Development of a Cryptocurrency Wallet</h4>
                            <p>
                              Our Crypto Wallets are built to support a wide
                              range of currencies while also providing
                              compatibility, storage, security,
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-12 first_section_crypto">
                          <Button
                            data-toggle="modal"
                            data-target="#myModal"
                            className="m-auto mt-4 margin_top_p"
                            aria-label="Schedule A Meeting"
                          >
                            Schedule A Meeting
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">
                        Premium Features of Our IEO Development
                      </h2>
                      <p className="text-center">
                        As a recognised IEO development firm, we supply you with
                        a feature-rich IEO module. With our IEO development
                        service, you may meet all of your requirements and
                        envision what your token should be.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12 pt-4">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">User Features</h2>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>01</span>
                      <h3>Apply IEO</h3>
                      <p>
                        With this, your users can apply to participate in the
                        IEO crowd sale by entering their Email, Name, Service
                        Type, Project Website, and Token Standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>02</span>
                      <h3>IEO Launchpad</h3>
                      <p>
                        This feature allows your users to learn about the status
                        of ongoing, upcoming, and completed projects.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12 pt-4 mt-5">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">Admin Features</h2>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>01</span>
                      <h3>Management of IEO Listings</h3>
                      <p>
                        You can manage and validate the user's Email, Name,
                        Service Type, Project Website, and Token Standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>02</span>
                      <h3>IEO Launchpad Administration</h3>
                      <p>
                        You can add or update the launchpad with this
                        functionality. They can edit the Start Date, End Date,
                        Social Links, and Website Name.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="row pt-5">
                  <div className="col-lg-6">
                    <div className="first_section_crypto white_security p-0">
                      <h2 className="">Advantages of IEO Development</h2>
                      <p>
                        As a leading Initial Exchange Offering development firm,
                        we have previously delivered cutting-edge deliverables
                        at a reasonable cost in the industry.
                      </p>

                      <ul>
                        <li>
                          <span>
                            <i className="bi bi-shield-fill-check"></i>
                          </span>
                          Exchange listing
                        </li>
                        <li>
                          <span>
                            <i className="bi bi-shield-fill-check"></i>
                          </span>
                          Faster funding
                        </li>
                        <li>
                          <span>
                            <i className="bi bi-shield-fill-check"></i>
                          </span>
                          Transparent
                        </li>
                        <li>
                          <span>
                            <i className="bi bi-shield-fill-check"></i>
                          </span>
                          Safe & Secure
                        </li>
                        <li>
                          <span>
                            <i className="bi bi-shield-fill-check"></i>
                          </span>
                          Quick Process
                        </li>
                        <li>
                          <span>
                            <i className="bi bi-shield-fill-check"></i>
                          </span>
                          High success rate
                        </li>
                      </ul>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label=" Get A Demo"
                      >
                        Get A Demo
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/cloudinary/advantage_ieo.webp")}
                      alt="Advantages of IEO Development"
                      className=""
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white pb-0">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        Our IEO Development Approach
                      </h2>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 d-flex justify-content-center align-items-center">
                        <img
                          src={require("../../image/cloudinary/ieo2.webp")}
                          alt="techstack"
                          className="img-fluid"
                        />
                      </div>
                      <div className="col-lg-6">
                        <ul className="list_fetures redult_memene">
                          <li>
                            <h4>Requirements Gathering</h4>
                            <p>
                              After taking into account all of your project
                              needs, our team will make the finest
                              recommendations to you. We'll move on after the
                              final decisions are made.
                            </p>
                          </li>
                          <li>
                            <h4>Tokenomics</h4>
                            <p>
                              Our crew divides the total supply into numerous
                              categories. These categories include partner
                              allocation, public sale, supply, and so forth.
                            </p>
                          </li>
                          <li>
                            <h4>IEO Development</h4>
                            <p>
                              To generate IEO tokens in accordance with token
                              standards, we employ blockchain and crypto
                              methods, as well as smart contracts to ensure
                              token encryption.
                            </p>
                          </li>
                          <li>
                            <h4>Security</h4>
                            <p>
                              To avoid online data breaches, our dedicated
                              security analysis team monitors the security level
                              and encryption status of the created tokens.
                            </p>
                          </li>
                          <li>
                            <h4>Listing Exchange</h4>
                            <p>
                              Once the final check is completed, we will begin
                              the exchange listing procedure to host the IEO on
                              a cryptocurrency exchange so that investors can
                              participate in the sale.
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="contanineee_circle">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="first_section_crypto colo_white card_CTAA">
                        <h2 className="">
                          Interested in creating your IEO Development? Book a
                          FREE Consultation Here!
                        </h2>
                        <a
                          href="tel:+91 80567 86622"
                          target="_blank"
                          className="grabcall"
                        >
                          Contact Us{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white ">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">
                        Our IEO Development Tech Stack
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Blockchain Networks</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Ethereum.webp")}
                            alt="blockchian"
                          />
                          <p>Ethereum</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Polkadot.webp")}
                            alt="blockchian"
                          />
                          <p>Polkadot</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Solana.webp")}
                            alt="blockchian"
                          />
                          <p>Solana</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/bnb-logo.png")}
                            alt="blockchian"
                          />
                          <p>BNB Chain</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/TRON.webp")}
                            alt="blockchian"
                          />
                          <p>TRON</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Smart Contract</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Truffle.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Truffle</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Openzappline.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Openzappline</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/HardHat.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>HardHat</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Infura.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Infura</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Quicknode.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Quicknode</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Ganache.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Ganache</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Pinata.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Pinata</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Metamask.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Metamask</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Chainlink.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Chainlink</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Programming Language</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/solo_img.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Solidity</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/v.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Vyper</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ai/rust_img.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Rust</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/Python.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Python</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/techstack.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>C++</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Framework</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/node.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Node JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/cloud.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Ether.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/wms.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>web3.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/react.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>React.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/anguler.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Anguler JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/net.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Next.JS</p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Wallet</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/ai/binance.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Binance</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/wall.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Trust Wallet</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/mask.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Metamask</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/c.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Coinbase</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ieo_icons/wallet.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>WalletConnect</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="section bg-light turstss_blss">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="first_section_crypto white_security white_benifit">
                          <h2 className="">
                            What makes Beleaf the finest IEO Development
                            Company?
                          </h2>
                          <p className="">
                            Beleaf, being a full-fledged Blockchain development
                            company, provides End-To-End IEO development
                            services to any blockchain-based projects. Our
                            deliverables will be exceptional since they will be
                            created by specialists and passionate blockchain
                            professionals in a cost-effective and timely manner.
                          </p>
                          <ul>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              End-to-End Services for IEO Development
                            </li>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Token development experience
                            </li>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Talented and enthusiastic team
                            </li>

                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Comprehensive work report
                            </li>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Excellent technical support
                            </li>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Project completion on time
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <img
                          src={require("../../image/cloudinary/iso1.webp")}
                          alt="What makes Beleaf the finest IEO Development
                          Company?"
                          className=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="contanineee_circle">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="first_section_crypto colo_white card_CTAA">
                        <h2 className="">
                          Flourish your Business With Initial Exchange Offerings
                          (IEO), Catch Our IEO Experts!
                        </h2>
                        <a
                          href="tel:+91 80567 86622"
                          target="_blank"
                          className="grabcall"
                        >
                          Book A Demo Now{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What exactly is an Initial Exchange Offering
                                    (IEO)?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    An IEO is a mechanism that directly sells
                                    tokens to eligible investors via a crypto
                                    exchange. Tokens are available for purchase
                                    via exchange in an IEO, and users can do so
                                    easily. Before being posted for sale on the
                                    exchange, the tokens must go through all
                                    validation steps. As a result, people can
                                    buy tokens with confidence.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    Is launching an IEO difficult?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    No. It will not be difficult to construct an
                                    IEO for your project with the correct
                                    development company. At Beleaf, we provide
                                    full-service token development, exchange
                                    integration, and global promotion for your
                                    IEO.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    What is IEO's future?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    We provide the best crypto bot creation
                                    services to help you create a safe,
                                    profitable, and efficient bot with trending
                                    features. We also provide a platform on
                                    which you can create a bot based on your
                                    procedures. Furthermore, IEOs have reached
                                    the maturity level required to become ILO,
                                    IGO, and IDO.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    Do you also provide IEO marketing services?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Yes, we have a specialised marketing team
                                    that specialises in digital marketing and
                                    will be able to promote your IEO to the
                                    market via various marketing and relevant
                                    channels. more.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      <Footer />
    </div>
  );
}

export default Cex;
